import { Component, OnInit } from '@angular/core';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { PaginationService } from 'src/app/helpers/pagination.service';
import { ToasterService } from 'src/app/helpers/toastr.service';
import { ReturnRequestOrderService } from './return-request-orders.service';

@Component({
  selector: 'app-return-request-orders',
  templateUrl: './return-request-orders.component.html',
  styleUrls: ['./return-request-orders.component.scss']
})
export class ReturnRequestOrdersComponent implements OnInit {

    public export_path:string = '';
    public export_loading:boolean = false;
    public download:string = '';

    closeResult = '';
    public search_term:string = '';
    public from_date:any = '';
    public to_date:any = '';

    constructor(
      private modalService: NgbModal,
      private _toastr: ToasterService,
      private _pagination: PaginationService,
      private _pageservice: ReturnRequestOrderService
    ) { }

    public map_type:string = 'all';
    public return_records: any = [];
    public current_page: number = 1;
    public offset: number = 0;
    public page_per_view: number = 20;
    public return_pagination: any = {};
    public page_per_view_options = [
        {
            value: 20,
            name: 20
        },
        {
            value: 40,
            name: 40
        }
    ];

    ngOnInit(): void {
        this.getorders();
    }

    setpage(page) {
        this.current_page = page;
        this.offset = (page - 1) * this.page_per_view;
        this.adminorders();
    }

    setpageperview() {
        this.current_page = 1;
        this.adminorders();
    }

    getorders() {
        this.search_term = '';
        this.from_date = '';
        this.to_date = '';
        this.page_per_view = 10;
        this.offset = 0;
        this.current_page = 1;
        this.adminorders();
    }

    getordersfilters(download=''){
        this.page_per_view = 10;
        this.offset = 0;
        this.current_page = 1;
        this.download = download;
        this.adminorders();
    }

    adminorders() {
        let data = { 
            limit: this.page_per_view, 
            offset: this.offset, 
            current_page: this.current_page, 
            search: this.search_term,
            from_date: this.from_date,
            to_date: this.to_date,
            map_type: this.map_type,
            download: this.download
        };
        this._pageservice.getorders(data).subscribe((data) => {
            if (data['status'] == "success") {
                if(data['download']){
                    this.export_path = data['path'];
                    this.export_loading = false;
                    this.download = '';
                }else{
                    this.download = '';
                    this.export_loading = false;
                    this.export_path = '';
                    this.return_records = data['records'];
                    let total_records = data['total_records'];
                    this.return_pagination = this._pagination.getPager(total_records, this.current_page, this.page_per_view);
                }
            } else if (data['status'] == "error") {
                this._toastr.error(data['message']);
            }
        });
    }

    open(content) {
        this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title', size: 'md', centered: true,}).result.then((result) => {
            this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
    }
    openWindowCustomClass(content) {
        this.modalService.open(content, { windowClass: 'modal-500' });
    }
    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return `with: ${reason}`;
        }
    }

}
